import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function Mechanism() {
  return <SectionWrapper data-id="element-133">
      <div className="bg-coral-light rounded-3xl p-8 md:p-12 relative overflow-hidden border border-coral/20" data-id="element-134">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-40 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-135"></div>

        <div className="relative z-10 text-center mb-8" data-id="element-136">
          <span className="inline-block py-1 px-3 rounded-full bg-coral text-white text-sm font-bold tracking-wider uppercase mb-4" data-id="element-137">
            El Descubrimiento
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal" data-id="element-138">
            El Método "Cortisol-Reset"
          </h2>
        </div>

        <div className="relative z-10 space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-139">
          <p className="text-center font-medium text-xl md:text-2xl text-coral mb-8" data-id="element-140">
            No contamos calorías, gestionamos señales.
          </p>
          <p data-id="element-141">
            Este protocolo utiliza la nutrición estratégica para apagar la
            alarma de estrés de tus células.
          </p>
          <p data-id="element-142">
            Al equilibrar la carga glucémica y reducir la inflamación sistémica,
            permites que tu cuerpo libere el exceso de líquido y acceda a la
            grasa acumulada en el abdomen.
          </p>
          <p className="font-semibold text-center mt-8 pt-6 border-t border-coral/20" data-id="element-143">
            Es nutrición biológica diseñada específicamente para la biología
            femenina de más de 40 años.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}